import { FC, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

const SupplyChainConnectorLayout: FC<
  React.PropsWithChildren<SupplyChainConnectorLayoutProps>
> = ({ children, more }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.layout}>
      <div className={classes.content}>{children}</div>
      <div className={classes.more}>{more}</div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    textAlign: 'center',
    height: '100%',
  },
  content: {
    flexGrow: 1,
    position: 'relative',
  },
  more: {
    flex: `0 0 20px`,
  },
}));

export interface SupplyChainConnectorLayoutProps {
  more?: ReactNode;
}

export default SupplyChainConnectorLayout;
